import { AfterViewInit, Component, OnInit } from '@angular/core';
declare function $(string:string): any;

@Component({
  selector: 'app-campus',
  templateUrl: './campus.component.html',
  styleUrls: ['./campus.component.scss']
})
export class CampusComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit(): void {
  }
  ngAfterViewInit(){
    $('img.lightbox').lightBox(); // Select all links with lightbox class

  }
}
